import React, { useContext, useState } from "react";
import { Card, DataTable, OneLineShowMore, Table, } from "@sscs/ui";
import { REPORT_PAGES_ROUTES } from "../../../../constants";
import { ExpandedRowDetails, SecretLiveness } from "../../../../ui";
import { CryptographyReferences, EndpointsTable, IssuesList, PolicyAudit, SecretExposure, StatusLabel, } from "../../../common";
import { ReportContext } from "../../../context";
import { useGetReportSummaryQuery } from "../../../services/shared.api";
import styles from "./secretsTable.module.scss";
const COLUMNS = [
    { id: "info", label: "Info", width: "70px" },
    {
        id: "status",
        label: "Status",
        sortProperty: "status",
        sortId: "secrets-sort-status",
        startReverse: true,
        width: "140px",
    },
    { id: "liveness", label: "Liveness", width: "90px" },
    {
        id: "exposure",
        label: "Exposure",
        sortProperty: "exposure",
        sortId: "secrets-sort-exposure-time",
        startReverse: true,
        width: "190px",
    },
    {
        id: "service",
        label: "Service",
        sortProperty: "service",
        sortId: "secrets-sort-service",
        width: "250px",
    },
    { id: "secret", label: "Secret", width: "100%" },
    { id: "canary", label: "Canary", width: "70px" },
    { id: "audit", label: "Audit", width: "80px" },
];
const SecretsTable = ({ secrets, matchCount, endpointFilter, filters, pagination, handlePaginationChange, sort, handleSortChange, }) => {
    const [focusedIndex, setFocusedIndex] = useState(0);
    const { reportId, diffId } = useContext(ReportContext);
    const { data: reportSummaryData } = useGetReportSummaryQuery({
        diff_report_id: diffId,
        ui_id: reportId,
    });
    const scanTime = reportSummaryData === null || reportSummaryData === void 0 ? void 0 : reportSummaryData.analysis_summary.scan_timestamp;
    return (React.createElement("div", { className: styles.container },
        React.createElement(DataTable, { chrome: "plain", tableClassName: styles["secrets-table"], columns: COLUMNS, sort: sort, onSortChange: handleSortChange, empty: { subject: "secrets", filters }, pagination: {
                id: "secrets-pagination",
                itemCount: matchCount,
                pagination,
                onChange: handlePaginationChange,
            } }, secrets.map((secret, index) => { var _a; return (React.createElement(DataTable.ExpandedRow, { id: `secrets-expand-row-${index}`, key: secret.id, focused: index === focusedIndex, onClick: () => setFocusedIndex(index) },
            React.createElement(DataTable.ExpandedRow.Summary, null,
                React.createElement(Table.Cell, null,
                    React.createElement(StatusLabel, { level: secret.policy.level, status: secret.policy.status })),
                React.createElement(Table.Cell, null,
                    React.createElement(SecretLiveness, { liveness: secret.liveness, exposed: secret.exposed })),
                React.createElement(Table.Cell, null,
                    React.createElement(SecretExposure, { exposed: secret.exposed, timestamp: secret.timestamp })),
                React.createElement(Table.Cell, null,
                    React.createElement("b", null, secret.service)),
                React.createElement(Table.Cell, null,
                    React.createElement(OneLineShowMore, { value: secret.secret
                            ? secret.secret
                            : "The entire extracted file is a secret" }),
                    React.createElement("div", { className: styles["secondary-text"] }, Number(secret.line_number) !== -1
                        ? `Line: ${secret.line_number.toString()}`
                        : `File offset: 0x${secret.file_offset.toString(16)}`)),
                React.createElement(Table.Cell, null, secret.canary ? "Yes" : "No"),
                React.createElement(Table.Cell, null, secret.audit.present ? "Yes" : "No")),
            React.createElement(DataTable.ExpandedRow.Details, null,
                React.createElement(ExpandedRowDetails, null,
                    React.createElement(ExpandedRowDetails.Aside, null,
                        secret.audit.present ? (React.createElement(PolicyAudit, { audit: secret.audit })) : null,
                        React.createElement(IssuesList, { violations: [secret.policy.id], to: REPORT_PAGES_ROUTES.ISSUES_ROUTE })),
                    React.createElement(ExpandedRowDetails.Main, null,
                        React.createElement(Card.Card, null,
                            React.createElement(Card.Title, null, secret.service),
                            React.createElement(Card.Content, null, (_a = secret.service_description) !== null && _a !== void 0 ? _a : "No description available")),
                        secret.cryptography.length ? (React.createElement(CryptographyReferences, { CBOMRoute: REPORT_PAGES_ROUTES.CBOM_ROUTE, references: secret.cryptography })) : (React.createElement(EndpointsTable, { endpoints: secret.endpoints, endpointLabelHighlight: endpointFilter || undefined, liveness: secret.liveness, scanTime: scanTime }))))))); }))));
};
export default SecretsTable;
//# sourceMappingURL=SecretsTable.js.map